import ICard from "../interface/card";
import Bulbasaur from '../assets/images/001.png';
import Charmander from '../assets/images/002.png';
import Squirtle from '../assets/images/003.png';
import Caterpie from '../assets/images/004.png';
import Weedle from '../assets/images/005.png';
import Pidgey from '../assets/images/006.png';
import Rattata from '../assets/images/007.png';
import Spearow from '../assets/images/008.png';
import Ekans from '../assets/images/009.png';
import Pikachu from '../assets/images/0010.png';
import Sandshrew from '../assets/images/0011.png';
import Nidoran from '../assets/images/0012.png';

export const cards: ICard[] = [
    {
      name: "Bulbasaur",
      img: Bulbasaur,
      id: 1,
    },
    {
      name: "Charmander",
      img: Charmander,
      id: 2
    },
    {
      name: "Squirtle",
      img: Squirtle,
      id: 3
    },
    {
      name: "Caterpie",
      img: Caterpie,
      id: 4
    },
    {
      name: "Weedle",
      img: Weedle,
      id: 5
    },
    {
      name: "Pidgey",
      img: Pidgey,
      id: 6
    },
    {
      name: "Rattata",
      img: Rattata,
      id: 7
    },
    {
      name: "Spearow",
      img: Spearow,
      id: 8
    },
    {
      name: "Ekans",
      img: Ekans,
      id: 9
    },
    {
      name: "Pikachu",
      img: Pikachu,
      id: 10
    },
    {
      name: "Sandshrew",
      img: Sandshrew,
      id: 11
    },
    {
      name: "Nidoran",
      img: Nidoran,
      id: 12
    },
  ];
